import App from './App.vue'
import { bootApp } from '@rhitics/vue/boot-app'
import { createRouter } from '@rhitics/vue/create-router'
import { createVuetifyApp } from '@rhitics/vue/create-vuetify-app'
import { createStore } from '@rhitics/vue/create-store'
import routes from './routes'
import { internalApps, home } from './config'
import { createI18n } from '@rhitics/vue/create-i18n'
import messages from './locales'

type VM = ReturnType<typeof createVuetifyApp>
;(async () => {
  // create router instance here if need it.
  const newRoutes = routes.concat(...internalApps.map(c => c.routes))

  const i18n = createI18n({ messages })

  const router = createRouter({ routes: newRoutes, base: '/' })

  const newStores = internalApps.filter(s => s.ns && s.store).map(({ ns, store }) => ({ ns, subModule: store() }))

  const store = createStore(newStores)

  // you can choose createApp or createVuetifyApp
  await bootApp<VM>(() => createVuetifyApp(App, { store, router, i18n }), home.shortName, '#app')
})()
